import React from 'react';

import { classnames } from '@/utils/classnames.ts';

export interface IconTileProps extends React.ComponentPropsWithRef<'span'> {
    // As large as an Avatar of the same size, which it stands in for: `header` in a page's header, `sm` in a list row,
    // `lg` on its own, e.g. above an empty page's title, `xs` beside a heading's text.
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'header';
    // Dashed and without a fill, in a placeholder card (Card's isPlaceholder).
    isPlaceholder?: boolean;
}

// A square with an icon where a picture would be, e.g. a client without a logo, a project or a pending invitation;
// its edge a shade darker, as the Avatar's it stands in for.
const IconTile = ({ size = 'sm', isPlaceholder = false, className, ...props }: IconTileProps) => (
    <span
        aria-hidden
        {...props}
        className={classnames(
            'flex shrink-0 items-center justify-center text-text-muted',
            isPlaceholder ? 'border-2 border-dashed border-border' : 'border border-text/8 bg-surface-muted',
            size === 'xs' && 'size-6 rounded-md [&_.lucide]:size-3',
            size === 'sm' && 'size-8 rounded-lg [&_.lucide]:size-3.5',
            size === 'md' && 'size-10 rounded-xl [&_.lucide]:size-4.5',
            size === 'lg' && 'size-13 rounded-2xl [&_.lucide]:size-5',
            size === 'header' &&
                'size-10 rounded-xl max-sm:size-16 max-sm:rounded-[1.25rem] [&_.lucide]:size-4.5 max-sm:[&_.lucide]:size-6',
            className
        )}
    />
);

export default IconTile;
